import Model, { belongsTo, hasMany } from '@ember-data/model';
import JournalContactModel from '../journal-contact';
import JournalDecisionModel from '../journal-decision';
import LineItemModel from '../line-item';
import PledgeModel from '../pledge';
import RecommendationModel from '../recommendation';
import V2TaskModel from '../v2-task';

export default class JournalContactDetailModel extends Model {
  @belongsTo('journal-contact', { async: false, inverse: null })
  journalContact!: JournalContactModel;
  @hasMany('journal-decision', { async: false, inverse: null })
  journalDecisions!: JournalDecisionModel[];
  @hasMany('pledge', { async: false, inverse: null }) pledges!: PledgeModel[];
  @hasMany('v2-task', { async: false, inverse: null }) tasks!: V2TaskModel[];
  @hasMany('recommendation', { async: false, inverse: null })
  recommendations!: RecommendationModel[];
  @belongsTo('line-item', { async: false, inverse: null })
  lastGift?: LineItemModel;
  @belongsTo('pledge', { async: false, inverse: null })
  existingPledge?: PledgeModel;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'all-funds/journal-contact-detail': JournalContactDetailModel;
  }
}
